import { Box } from '@primer/react';
import { StatusLabel } from '@primer/gatsby-theme-doctocat';
import StorybookLink from '@primer/gatsby-theme-doctocat/src/components/storybook-link';
import LookbookLink from '@primer/gatsby-theme-doctocat/src/components/lookbook-link';
import SourceLink from '@primer/gatsby-theme-doctocat/src/components/source-link';
import * as React from 'react';
export default {
  Box,
  StatusLabel,
  StorybookLink,
  LookbookLink,
  SourceLink,
  React
};